<script>
  import Container from "./../shared/Container.svelte";
  import SectionHeading from "./../shared/SectionHeading.svelte";
  import Layout from "../Layout/Layout.svelte";
  import Modal from "../shared/Modal.svelte";
  import Select from "svelte-select";
  import config from "../stores/config";
  import axios from "axios";
  import * as ls from "local-storage";
  import countries from "../stores/countries";
  import { Circle2 } from "svelte-loading-spinners";
  import AdminCard from "../components/AdminCard.svelte";
  import { onMount } from "svelte";
  import Loading from "../shared/Loading.svelte";
  import Empty from "../shared/Empty.svelte";
  import t from "../utils/t";
  import * as animateScroll from "svelte-scrollto";

  // Adding A New Admin-------------------------------------------------------------------
  let newAdmin = {
    fullname: null,
    username: null,
    password: null,
    confirmPassword: null,
    email: null,
    tel: null,
    country: null,
  };

  let showAddAdminForm = false;
  let addNewAdminLoading = false;

  $: newAdmin.username = newAdmin.email;

  const handleAddNewAdmin = (e) => {
    if (!newAdmin.country) {
      alert("⚠ Country Missing!");
      return;
    } else if (!newAdmin.tel) {
      alert("⚠ Telephone Missing!");
      return;
    } else if (!newAdmin.email) {
      alert("⚠ Email Missing!");
      return;
    } else if (!newAdmin.password) {
      alert("⚠ Address Missing!");
      return;
    } else if (!newAdmin.password) {
      alert("⚠ Password Missing!");
      return;
    } else if (newAdmin.password != newAdmin.confirmPassword) {
      alert("⚠ Password and Repeated Password Don't Match");
      return;
    }

    addNewAdminLoading = true;

    axios
      .post(
        `${$config.backendURL}/users/add-admin`,
        { ...newAdmin, country: newAdmin.country.value },
        {
          headers: { authorization: ls.get("jwt") },
        }
      )
      .then((res) => {
        showAddAdminForm = false;
        addNewAdminLoading = false;

        newAdmin = {
          fullname: null,
          username: null,
          password: null,
          confirmPassword: null,
          email: null,
          tel: null,
          country: null,
        };

        fetchAdmins();
      })
      .catch((err) => {
        addNewAdminLoading = false;
        console.log(err);
        alert(err);
      });
  };

  // Query For Admins ------------------------------------------------------------------------------
  let admins = null;
  let queryURL = "";

  let page = 1;
  let searchKey = "";

  const fetchAdmins = () => {
    admins = null;
    queryURL = `${$config.backendURL}/users/page/${page}?`;
    queryURL += `&searchKey=${searchKey || ""}`;

    axios
      .get(queryURL, {
        headers: { authorization: ls.get("jwt") },
      })
      .then((res) => {
        admins = res.data;
        newAdmin.country = $config.currentUser.country;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchAdmins();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchAdmins();
  };

  onMount(() => {
    animateScroll.scrollToTop();
    fetchAdmins();
  });
</script>

<svelte:head>
  <title>Manage Administrators | SAMAKI EXPRESS</title>
</svelte:head>

<Layout>
  <Modal
    show={showAddAdminForm}
    on:modalClose={() => {
      showAddAdminForm = false;
    }}
  >
    <div class="grid gap-y-2">
      {#if $config.currentUser.role == "super-admin"}
        <Select
          placeholder="Country"
          bind:selectedValue={newAdmin.country}
          items={$countries}
        />
      {/if}
      <input
        bind:value={newAdmin.fullname}
        type="text"
        placeholder="Full Name"
        required
      />
      <input
        bind:value={newAdmin.tel}
        type="text"
        placeholder="Telephone"
        required
      />
      <input bind:value={newAdmin.email} type="text" placeholder="Email" />
      <input
        bind:value={newAdmin.password}
        type="password"
        placeholder={`Set a password for ${
          newAdmin.fullname || "the new admin"
        }`}
        required
      />
      <input
        bind:value={newAdmin.confirmPassword}
        type="password"
        placeholder={`Repeat the password`}
        required
      />
      {#if addNewAdminLoading}
        <div class="grid grid-cols-1 gap-8">
          <div class="btn btn-primary">
            <Circle2
              size="25"
              unit="px"
              colorOuter="#F4A261"
              colorCenter="#40B3FF"
              colorInner="#676778"
            />
            <span class="ml-4">Please Wait...</span>
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="flex">
          <button class="btn btn-primary" on:click={handleAddNewAdmin}>
            <ion-icon name="checkmark-circle" class="text-2xl mr-3" />
            Save
          </button>
          <button
            class="ml-4 btn btn-secondary"
            on:click={(e) => (showAddAdminForm = false)}
          >
            <ion-icon name="close-circle" class="text-2xl mr-3" />
            Close
          </button>
        </div>
      {/if}
    </div>
  </Modal>

  <SectionHeading text1="Manage Administrators" />

  <Container>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <button
        class="btn btn-primary"
        on:click={(e) => {
          showAddAdminForm = true;
        }}
        style="width: 100%;"
      >
        <ion-icon name="add-circle" class="text-2xl mr-3" />
        Add A New Admin
      </button>

      <input
        type="text"
        bind:value={searchKey}
        on:input={fetchAdmins}
        placeholder="Search by name, country..."
      />
    </div>
  </Container>

  <Container>
    {#if admins == null}
      <Loading text="Loading Admins..." />
    {:else}
      <div class="my-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {#each admins as adm (adm._id)}
          <div class="">
            <AdminCard
              {...adm}
              on:delete={() => {
                page = 1;
                searchKey = "";
                fetchAdmins();
              }}
              on:update={() => {
                page = 1;
                searchKey = "";
                fetchAdmins();
              }}
            />
          </div>
        {:else}
          <div class="col-span-full">
            <Empty />
          </div>
        {/each}
      </div>

      <div class="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <button
          class="btn btn-secondary"
          style="width: 100%;"
          on:click={() => {
            handleNextPage();
          }}
        >
          <ion-icon name="arrow-forward-circle" class="text-2xl mr-2" />
          {t({ en: "Page Suiv.", fr: "Page Suiv." })}
        </button>
        <button
          class="btn btn-secondary"
          style="width: 100%;"
          on:click={() => {
            handlePrevPage();
          }}
        >
          <ion-icon name="arrow-back-circle" class="text-2xl mr-2" />
          {t({ en: "Page Suiv.", fr: "Page Prec." })}
        </button>
      </div>
    {/if}
  </Container>
</Layout>
